import {
    CloseDropdowns,
    DropdownOptionClicked,
    KeyboardNavigationStarted,
    RemoveMultiSelectChoice,
    ToggleDropdown,
    SelectOptionsChanged
} from './Event';
import {state} from './State';
import {
    closeDropdown,
    deselectMultiOption,
    navigate,
    openDropdown,
    outOfVerticalBounds,
    selectMultiOption,
    selectSingleOption,
} from './Dom';

/** @param {ToggleDropdown} event */
export const toggleDropdownHandler = event => {
    document.querySelectorAll('.select-container').forEach(container => {
        if (container.classList.contains('active') && container !== event.selectContainer) {
            closeDropdown(container);
        }
    });

    if (!event.selectContainer.classList.contains('active')) {
        openDropdown(event.selectContainer);
    } else {
        closeDropdown(event.selectContainer);
    }
};

/** @param {CloseDropdowns} event */
export const closeDropdownsHandler = (event) => {
    document.querySelectorAll('.select-container').forEach(container => {
        if (container.classList.contains('active')) {
            if (event.restoreFocus) {
                container.focus({preventScroll: true});
            }

            closeDropdown(container);
        }
    });

    state.hasActiveDropdown = false;
};

/** @param {RemoveMultiSelectChoice} event */
export const removeMultiSelectChoiceHandler = event => {
    const optionValue = event.choice.dataset.value;
    const option = event.selectContainer.querySelector('.options li[data-value="' + optionValue + '"]');
    const selectElement = event.selectContainer.querySelector('select');

    deselectMultiOption(option, event.selectContainer);
    document.dispatchEvent(new SelectOptionsChanged(event.selectContainer));

    selectElement.dispatchEvent(new Event('input', {bubbles: true}))
    selectElement.dispatchEvent(new Event('change', {bubbles: true}))
};

/** @param {DropdownOptionClicked} event */
export const dropdownOptionClickedHandler = event => {
    if (event.selectContainer.classList.contains('links')) {
        const link = event.option.querySelector('a');

        if (link) {
            link.click();
        }

        return;
    }

    const isMultiSelect = event.selectContainer.classList.contains('multiple');
    const selectElement = event.selectContainer.querySelector('select');

    if (isMultiSelect) {
        if (event.option.classList.contains('selected')) {
            deselectMultiOption(event.option, event.selectContainer);
        } else {
            selectMultiOption(event.option, event.selectContainer);
        }

        if (event.fromKeyboard && event.key === 'Escape') {
            event.selectContainer.focus();
        }
    } else {
        selectSingleOption(event.selectContainer, event.option, selectElement);

        if (event.fromKeyboard) {
            event.selectContainer.focus();
        }
    }

    document.dispatchEvent(new SelectOptionsChanged(event.selectContainer));

    selectElement.dispatchEvent(new Event('input', {bubbles: true}))
    selectElement.dispatchEvent(new Event('change', {bubbles: true}))
};

export const clickSelectContainer = (target, selectContainer) => {
    if (target.closest('.toggle-container') !== null) {
        if (target.classList.contains('fa-xmark')) {
            return document.dispatchEvent(new RemoveMultiSelectChoice(selectContainer, target.closest('span')));
        }

        return document.dispatchEvent(new ToggleDropdown(selectContainer));
    }

    const option = target.closest('.dropdown li');

    if (option) {
        document.dispatchEvent(new DropdownOptionClicked(selectContainer, option));
    }
};

/** @param {KeyboardEvent} event */
export const keyupHandler = event => {
    if (event.key === 'Escape' && state.hasActiveDropdown) {
        return document.dispatchEvent(new CloseDropdowns(true));
    }

    const selectContainer = event.target.closest('.select-container:not(od-select)');

    if (selectContainer && selectContainer.classList.contains('active')) {
        if (event.key === 'Enter') {
            const options = selectContainer.querySelector('.options');
            const option = options.querySelector('.focus') || options.querySelector(':hover');

            if (option !== null) {
                document.dispatchEvent(new DropdownOptionClicked(selectContainer, option, true, event.key));
            }
        }
    }


};

/** @param {KeyboardNavigationStarted} event */
export const keyboardNavigationStartedHandler = event => {
    event.selectContainer.classList.add('keyboard-navigation');

    const stopKeyboardNavigation = () => {
        event.selectContainer.classList.remove('keyboard-navigation');
        event.selectContainer.querySelector('.focus').classList.remove('focus');
        event.selectContainer.querySelector('.options').removeEventListener('mousemove', stopKeyboardNavigation);
    };

    event.selectContainer.querySelector('.options').addEventListener('mousemove', stopKeyboardNavigation);
};

export const keydownHandler = event => {
    if (event.key === 'Enter' && state.hasActiveDropdown) {
        // when in the search text input, hitting enter shouldn't submit the whole form
        if (event.target.closest('.select-container input')) {
            event.preventDefault();
        }
    }

    const selectContainer = event.target.closest('.select-container');

    if (selectContainer) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();

            const direction = event.key === 'ArrowUp' ? 'up' : 'down';

            if (!selectContainer.classList.contains('keyboard-navigation')) {
                document.dispatchEvent(new KeyboardNavigationStarted(selectContainer));
            }

            if (!selectContainer.classList.contains('active')) {
                openDropdown(selectContainer);
            }

            const selectedOption = navigate(selectContainer, direction);

            if (selectedOption && outOfVerticalBounds(selectedOption, selectContainer.querySelector('.options'))) {
                selectedOption.scrollIntoView(direction === 'up');
            }
        }

        if (event.key === 'Tab' && selectContainer.classList.contains('active')) {
            document.dispatchEvent(new ToggleDropdown(selectContainer, true));
        }
    }
};
